'use strict';
import { Component, Inject, Input} from 'ng-metadata/core';
import {CitationService} from './citation.service';
import {CslUtils} from "../../../nddUtils/cslUtils.service";
import {SelectTextUtil} from '../../../infra/selectTextUtil';
import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {SmoothScrollUtil} from "../../../nddUtils/smoothScrollUtil.service";
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {StorageUtil} from "../../../infra/storageUtil.service";
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {isBrowserSafari} from "../../../infra/browserSniffer";
import {PrimolyticsService} from '../../../analytics/primolytics.service';
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service'

const get = require('lodash/get');

@Component({
    providers: [CitationService],
    'selector': 'prm-citation',
    templateUrl: 'components/search/actions/citation/citation.html'
})

export class PrmCitation {
	public isError				: boolean;
	public inProgress			: boolean;
	public lastCitation			: string;
	public selectedStyle		: string;
	public testCitation		: string;
	
	@Input() private item		: PrimoResponse.IDoc;

	private CITEPROC_ENGINE: 		string = 'citeproc_engine';
	private CITEPROC_ENGINE_SERVER: string = 'server';
	private CITEPROC_ENGINE_CLIENT: string = 'client';
	private CITEPROC_ENGINE_BOTH: 	string = 'both';
    private hoveredStyle: 	string;
    private selectedCitationName: 	string;
	private cslTypePerStyle = {apa: 'type2'};
	private cslDataPerType = {};

    constructor (private citationService : CitationService,
				 private cslUtils: CslUtils,
                 @Inject('collectionIcons') private collectionIcons,
				 private selectTextUtil:SelectTextUtil,
                 private pnxUtil:PnxUtil,
                 private mediaQueries: MediaQueries,
                 private primolyticsService: PrimolyticsService,
                 private smoothScrollUtil: SmoothScrollUtil,
                 private configurationUtil: ConfigurationUtil,
                 private storageUtil: StorageUtil,
				 private mtCache: MappingTablesCache,
                 @Inject('$timeout') private $timeout,
                 @Inject('$element') private $element){
        this.isError= false;
        this.inProgress=false;
        this.lastCitation='';
    }

    public ngOnInit() {
        this.selectedStyle = this.lastStyle || this.getStyles()[0];
        this.getCitation(this.selectedStyle);
        this.addAriaAlertToInProgressMsg();
    }

    private addAriaAlertToInProgressMsg(){
        this.$timeout(()=>{
            let inProgressElm = this.$element[0].querySelector('#citationInProgress') as HTMLElement;
            if(inProgressElm) {
                inProgressElm.setAttribute('role', 'alert');
            }
        }, 0);
    }
	
    set lastStyle(style){
        this.storageUtil.localStorage.setItem('last_citation_style', style)
    }

    get lastStyle(){
        return this.storageUtil.localStorage.getItem('last_citation_style');
    }

    public getStyles(){
        if(this.configurationUtil.isSuprima()) {
            return this.citationService.getAvailableStyles();
        }else{
            return this.citationService.getPrimoAvailableStyles(); // Primo uses a different MT than Suprima
        }
    }

    public setHoveredStyle(style) {
        this.hoveredStyle = style;
    }
    public getHoveredClass(style){
        return (this.hoveredStyle === style) ? 'show' : 'hide';
    }

    get layoutPos():string{
        return this.detectMobile()? "column":"row";
    }


    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }

	public getInitialTab():number{
		let index = this.getStyles().indexOf(this.selectedStyle);
        let returnedIndex = 1;

        if(index < 0){
            returnedIndex = 1;
		}else{
            returnedIndex = index + 1;
        }
        this.smoothScrollUtil.focusOn('citationsTab'+returnedIndex);
		return returnedIndex;
	}

    public getCitation(style){
		this.isError = false; // Reset error state before new attempt
        this.item["citationStyle"] = style ? style.replace(/^(csl\.)/,"") : ''; // sending the style in the beacon call        
        this.primolyticsService.doBeaconReport({'p': 'sendTo', 'op': 'Citation'}, this.item, this.primolyticsService.getTimestamp());
        if(this.getStyles()){
            let citationStyleIndex = this.getStyles().indexOf(style)+1;
            this.primolyticsService.doBeaconReport({'p': 'sendTo', 'op': 'CitationStyle' + citationStyleIndex}, this.item, this.primolyticsService.getTimestamp());
        }
        
        if(!this.configurationUtil.isSuprima()) {
            this.getPrimoCitation(style);
            return;
        }
        this.inProgress = true;
        this.addAriaAlertToInProgressMsg();

		// Set timeout to add an error message after 15 seconds if still in progress
		this.$timeout(() => {
			if (this.inProgress) {
				console.error('Failed to generate citation for this style format:'+style);
				this.onError();
			}
		}, 15000);
		let citeprocEngine = this.getCiteprocEngine();

		if ([this.CITEPROC_ENGINE_SERVER, this.CITEPROC_ENGINE_BOTH].includes(citeprocEngine)) {
	        this.citationService.getCitation(style, this.item.pnx, this.item.delivery)
	            .then((response) => this.onSuccess(response), (response) => this.onError(response));
		}
		
		if ([this.CITEPROC_ENGINE_CLIENT, this.CITEPROC_ENGINE_BOTH].includes(citeprocEngine)) {
			let apiStyle = style.replace(/^(csl\.)/,"");
			let type = this.cslTypePerStyle[apiStyle];
			if (!type) {
				type = 'type1'; //default
			}
			let cslData = this.cslDataPerType[type];
			if (cslData) {
				this.updateCitation(cslData,apiStyle);
				this.inProgress = false;
			} else {
				this.cslUtils.getCslFromServer(style,this.item.pnx,this.item.delivery)
					.then((response) => this.onSuccess(response, apiStyle), (response) => this.onError(response));
			}

		}
		
        this.selectedStyle = style;
        this.lastStyle = style;
		
    }
    
    public getPrimoCitation(style){
		let citeprocEngine = this.getCiteprocEngine();
		if(!style) {
			return;
		} 
		
        // removing "csl." from the label code, that was added to prevent code duplication with labels from other sources (EasyBib)
        let source = style.startsWith('csl.') ? 'csl' : '' ;
        let apiStyle = style.replace(/^(csl\.)/,"");
        this.inProgress = true;

		if (source !== 'csl') { //reset test in case of both
			this.testCitation = '';
		}
		
		if (source !== 'csl' || [this.CITEPROC_ENGINE_SERVER, this.CITEPROC_ENGINE_BOTH].includes(citeprocEngine)) {
	        // adding "csl." to the payload, as the citation source, to prevent code duplication with labels from other sources (EasyBib)            
	        this.citationService.getCitation(apiStyle, this.item.pnx, this.item.delivery, source)
	            .then((response) => this.onSuccess(response), (response) => this.onError(response));
		}
		
		if (source === 'csl' && [this.CITEPROC_ENGINE_CLIENT, this.CITEPROC_ENGINE_BOTH].includes(citeprocEngine)) {
			let type = this.cslTypePerStyle[apiStyle];
			if (!type) {
				type = 'type1'; //default
			}
			let cslData = this.cslDataPerType[type];
			if (cslData) {
				this.updateCitation(cslData,apiStyle);
				this.inProgress = false;
			} else {
				this.cslUtils.getCslFromServer(apiStyle,this.item.pnx,this.item.delivery,source)
					.then((response) => this.onSuccess(response ,apiStyle), (response) => this.onError(response));
			}
		}
		
        this.selectedStyle = style;
        this.lastStyle = style;
		
    }

    public lastCitationDecoded() {
		let citeProcEngine = this.getCiteprocEngine();
		if ([this.CITEPROC_ENGINE_SERVER, this.CITEPROC_ENGINE_BOTH].includes(citeProcEngine)) {
        	return this.citationService.decodeHtmlEntities(this.lastCitation);
		}
		return this.lastCitation;
    }
	
    private getCitationId() {
        return 'citation'+ this.getRecordId();
    }
    //selects (highlights) citation text
    public selectText() {
        this.selectTextUtil.selectText(this.getCitationId());
    }

    public getRecordId(){
        return this.pnxUtil.getValue(this.item, 'control', 'recordid');
    }

	public isTestMode() {
		let citeprocEngine = this.getCiteprocEngine();
		return [this.CITEPROC_ENGINE_BOTH].includes(citeprocEngine) && this.testCitation;
	}
	
	private onSuccess(response, apiStyle) {
		this.inProgress = false;
		let citeprocEngine = this.getCiteprocEngine();
		
		 switch (citeprocEngine) {
            case this.CITEPROC_ENGINE_SERVER:
                if(response.data.status && response.data.status === 'ok'){
					this.isError = false;			
		            if(this.configurationUtil.isSuprima()) {
		                let data= response.data;
		                this.lastCitation = this.citationService.decodeCitationText(data["citation"]);
		                this.$timeout(()=>{
		                    this.citationService.loadCitationStyle(data, this.$element);
		                }, 0);
		            } else {
		                this.lastCitation = this.citationService.decodeCitationText(response.data.data);
		                this.$timeout(()=>{
		                    this.citationService.loadCitationStyle(response.data, this.$element);
		                }, 0);
		            }
				} else {
					console.error('Citation failure!', response.data.msg);
					this.onError(response);
				}
                break;
            case this.CITEPROC_ENGINE_CLIENT:
				if (apiStyle) {
					this.isError = false;
					this.updateCitation(response,apiStyle);
				} else {
					if(response.data.status && response.data.status === 'ok'){
						this.isError = false;
		            	if(this.configurationUtil.isSuprima()) {
		                	let data= response.data;
		                	this.lastCitation = this.citationService.decodeCitationText(data["citation"])
		                	this.$timeout(()=>{
		                    	this.citationService.loadCitationStyle(data, this.$element);
		                	}, 0);
		            	} else {
		                	this.lastCitation = this.citationService.decodeCitationText(response.data.data);
		                	this.$timeout(()=>{
		                    	this.citationService.loadCitationStyle(response.data, this.$element);
		                	}, 0);
		            	}
					} else {
						console.error('Citation failure!', response.data.msg);
						this.onError(response);
					}
				}
                break;
            case this.CITEPROC_ENGINE_BOTH:
				if(response.data.status && response.data.status === 'ok'){
					this.isError = false;			
		            if(this.configurationUtil.isSuprima()) {
		                let data= response.data;
		                this.lastCitation = this.citationService.decodeCitationText(data["citation"]);
		                this.$timeout(()=>{
		                    this.citationService.loadCitationStyle(data, this.$element);
		                }, 0);
		            } else {
		                this.lastCitation = this.citationService.decodeCitationText(response.data.data);
		                this.$timeout(()=>{
		                    this.citationService.loadCitationStyle(response.data, this.$element);
		                }, 0);
		            }
				} else {
					console.error('Citation failure!', response.data.msg);
					this.onError(response);
				}
				let docLang = this.getItemLanguage();
				this.testCitation = this.cslUtils.handleCslData(response, apiStyle,docLang).citation;
                break;
            default:
                console.error('Invalid citeproc engine '+citeprocEngine);
        }


	}

	private updateCitation(response,apiStyle) {
		let docLang = this.getItemLanguage();
		let data;
		data = this.cslUtils.handleCslData(response, apiStyle,docLang);
		this.lastCitation = data.citation;

		this.$timeout(()=>{
			this.citationService.loadCitationStyle(data, this.$element);
		}, 0);

		let type = this.cslTypePerStyle[apiStyle];
		if (!type) {
			type = 'type1'; //default
		}
		this.cslDataPerType[type] = response;
	}

	private getItemLanguage() {
		let language = get(this.item,'pnx.display.language');
		if (angular.isArray(language)) {
            language = language[0];
        }

		return language;
	}
	
	private getCiteprocEngine() {
		let citeprocEngine = this.mtCache.findByProperties(this.mtCache.tables.INSTITUTION_PROPERTIES, { source1: this.CITEPROC_ENGINE });
		if (citeprocEngine.length > 0) {
			return citeprocEngine[0].target;
		}
		return this.CITEPROC_ENGINE_CLIENT;
	}
	
	private onError(response){
		this.inProgress = false;
		this.isError = true;
	}

    displayCopyButton(){
		return !(/iPod/.test(navigator.userAgent) && !window.MSStream);
    }

    public isSafariBrowse() {
        return isBrowserSafari();
    }

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/citation/citation.directive.ts